import React from 'react';
import styled from 'styled-components';
import { pxToRem } from '@quiqupltd/qu-react-sdk/lib/utils/styles';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';

const Container = styled.div`
  text-align: center;
  padding: 15px;
  border: 1px dashed ${props => props.theme.midnight400};
`;

export const Title = styled.p`
  font-size: ${pxToRem(20)};
  font-weight: 400;
  color: ${props => props.theme.midnight400};
  margin: 0 0 5px 0;

  ${media.up('phone')`
    font-size: ${pxToRem(18)};
    margin: 0 0 10px 0;
  `};
`;

export const Subtitle = styled.div`
  font-size: ${pxToRem(16)};
  font-weight: 300;
  color: ${props => props.theme.grey};
  margin: 0;
`;

export const RateThankYou = () => {
  return (
    <Container>
      <Title>Thank you for rating our services!</Title>
      <Subtitle>Your feedback will be used improve how to best serve our customers</Subtitle>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/app/order-card/completed/rate-experience/rate-thankyou.js